import { Outlet } from 'react-router';
import { AsideLayout, type AsideItem } from './AsideMenu';

const items: AsideItem[] = [
  { label: 'Clients', icon: 'person_outline', to: '/home/manage/clients', alsoActiveFor: ['/home/manage/addClient'] },
  { label: 'Users', icon: 'people_outline', to: '/home/manage/users', alsoActiveFor: ['/home/manage/addUser'] },
];

export function ManageLayout() {
  return (
    <AsideLayout items={items} collapsible={false}>
      <Outlet />
    </AsideLayout>
  );
}
